<script>
export default {
    name: "scriptImport",
    props: {
        src: {
            type: String,
            required: true
        }
    },
    render(createElement) {
        let self = this;
        return createElement("script", {
            attrs: {
                type: "text/javascript",
                src: this.src
            },
            on: {
                load(event) {
                    self.$emit("load", event);
                },
                error(event) {
                    self.$emit("error", event);
                }
            }
        });
    }
};
</script>
